import { createFileRoute } from '@tanstack/react-router';
import { PayLinkPage } from '@/features/billing/pages/pay-link-page';

/** Public (no session): the payment link in the owner's email. */
export const Route = createFileRoute('/_public/pay/$token')({ component: PayRoute });

function PayRoute() {
  const { token } = Route.useParams();
  return <PayLinkPage token={token} />;
}
